const en = {
    app: { name: "Uzverse" },
    language: { tr: "Türkçe", en: "English", switch: "Language" },
    actions: {
        save: "Save",
        cancel: "Cancel",
        undo: "Undo",
        approve: "Approve",
        reject: "Reject",
        retry: "Retry",
    },
    ui: {
        theme: { label: "Theme", system: "Auto", light: "Light", dark: "Dark" },
        copy: { copy: "Copy", copied: "Copied" },
        state: {
            loading: "Loading…",
            empty: "Nothing here yet.",
            error: "Something went wrong.",
            retry: "Try again",
        },
        toast: { dismiss: "Dismiss" },
        enroll: {
            title: "Set up two-step verification",
            step: "Step {{n}} of {{total}}",
            scan: "Scan this QR code with an authenticator app, for example Google Authenticator, 1Password or Aegis.",
            qrLabel: "QR code for your authenticator app",
            manualTitle: "Cannot scan? Enter the key by hand",
            manualKey: "Setup key",
            openLink: "Open in authenticator app",
            codeLabel: "6-digit code",
            codeHint: "Enter the code your app shows now to confirm.",
            confirm: "Confirm",
            confirming: "Checking…",
        },
        password: {
            title: "Choose a new password",
            forcedIntro: "Your password was set by someone else. Choose your own before you continue.",
            intro: "Enter your current password and a new one.",
            current: "Current password",
            next: "New password",
            repeat: "Repeat the new password",
            hint: "At least {{min}} characters.",
            submit: "Change password",
            working: "Changing…",
            signOut: "Sign out",
            tooShort: "The new password must be at least {{min}} characters.",
            mismatch: "The two new passwords do not match.",
            same: "The new password must be different from the current one.",
            wrongCurrent: "The current password is not correct.",
        },
        recovery: {
            title: "Save your recovery codes",
            hint: "Each code works once if you lose access to your authenticator. They are shown only now; store them somewhere safe.",
            copyAll: "Copy codes",
            download: "Download as text",
            fileHeader: "Uzverse recovery codes",
            fileNote: "Each code works once. Keep this file somewhere safe.",
            saved: "I saved these codes somewhere safe",
            continue: "Continue",
        },
    },
    errors: {
        invalid_input: "Some of the information is not valid.",
        unauthenticated: "Please sign in.",
        permission_denied: "You do not have permission to do this.",
        not_found: "We could not find that.",
        conflict: "This changed in the meantime. Please review and try again.",
        approval_required: "This needs approval before it runs.",
        budget_exceeded: "The budget for this work has been reached.",
        rate_limited: "Too many requests right now. We will continue shortly.",
        exhausted: "No connection is available right now. The owner has been notified.",
        not_implemented: "This is not available yet.",
        unavailable: "The service is temporarily unavailable.",
        internal: "Something went wrong. The owner has been notified.",
    },
};
const tr = {
    app: { name: "Uzverse" },
    language: { tr: "Türkçe", en: "English", switch: "Dil" },
    actions: {
        save: "Kaydet",
        cancel: "Vazgeç",
        undo: "Geri al",
        approve: "Onayla",
        reject: "Reddet",
        retry: "Tekrar dene",
    },
    ui: {
        theme: { label: "Tema", system: "Otomatik", light: "Aydınlık", dark: "Karanlık" },
        copy: { copy: "Kopyala", copied: "Kopyalandı" },
        state: {
            loading: "Yükleniyor…",
            empty: "Henüz bir şey yok.",
            error: "Bir şeyler ters gitti.",
            retry: "Tekrar dene",
        },
        toast: { dismiss: "Kapat" },
        enroll: {
            title: "İki adımlı doğrulamayı kur",
            step: "Adım {{n}} / {{total}}",
            scan: "Bu QR kodunu bir doğrulayıcı uygulamayla (ör. Google Authenticator, 1Password veya Aegis) tarayın.",
            qrLabel: "Doğrulayıcı uygulamanız için QR kodu",
            manualTitle: "Tarayamıyor musunuz? Anahtarı elle girin",
            manualKey: "Kurulum anahtarı",
            openLink: "Doğrulayıcı uygulamada aç",
            codeLabel: "6 haneli kod",
            codeHint: "Onaylamak için uygulamanın şu an gösterdiği kodu girin.",
            confirm: "Onayla",
            confirming: "Kontrol ediliyor…",
        },
        password: {
            title: "Yeni bir şifre belirleyin",
            forcedIntro: "Şifrenizi başkası belirledi. Devam etmeden önce kendi şifrenizi seçin.",
            intro: "Mevcut şifrenizi ve yeni şifrenizi girin.",
            current: "Mevcut şifre",
            next: "Yeni şifre",
            repeat: "Yeni şifreyi tekrarlayın",
            hint: "En az {{min}} karakter.",
            submit: "Şifreyi değiştir",
            working: "Değiştiriliyor…",
            signOut: "Çıkış yap",
            tooShort: "Yeni şifre en az {{min}} karakter olmalı.",
            mismatch: "İki yeni şifre birbiriyle uyuşmuyor.",
            same: "Yeni şifre mevcut şifreden farklı olmalı.",
            wrongCurrent: "Mevcut şifre doğru değil.",
        },
        recovery: {
            title: "Kurtarma kodlarınızı kaydedin",
            hint: "Doğrulayıcıya erişimi kaybederseniz her kod bir kez kullanılabilir. Yalnızca şimdi gösterilir; güvenli bir yerde saklayın.",
            copyAll: "Kodları kopyala",
            download: "Metin olarak indir",
            fileHeader: "Uzverse kurtarma kodları",
            fileNote: "Her kod bir kez çalışır. Bu dosyayı güvenli bir yerde saklayın.",
            saved: "Bu kodları güvenli bir yere kaydettim",
            continue: "Devam et",
        },
    },
    errors: {
        invalid_input: "Bilgilerin bir kısmı geçerli değil.",
        unauthenticated: "Lütfen giriş yapın.",
        permission_denied: "Bunu yapmaya yetkiniz yok.",
        not_found: "Aradığınızı bulamadık.",
        conflict: "Bu arada değişiklik oldu. Lütfen kontrol edip tekrar deneyin.",
        approval_required: "Bu işlem çalışmadan önce onay gerekiyor.",
        budget_exceeded: "Bu iş için ayrılan bütçeye ulaşıldı.",
        rate_limited: "Şu anda çok fazla istek var. Birazdan devam edeceğiz.",
        exhausted: "Şu anda kullanılabilir bağlantı yok. Sahibine bildirildi.",
        not_implemented: "Bu henüz kullanılamıyor.",
        unavailable: "Servis geçici olarak kullanılamıyor.",
        internal: "Bir şeyler ters gitti. Sahibine bildirildi.",
    },
};
/** The `common` namespace: app-wide labels and one message per core error code. */
export const commonMessages = {
    namespace: "common",
    messages: { en, tr },
};
//# sourceMappingURL=common.js.map